import React from "react";
import { createRoot } from "react-dom/client";
import AircraftOwnershipData from "./AircraftOwnershipData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderAircraftOwnershipData: unknown;
	}
}

export function renderAircraftOwnershipData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<AircraftOwnershipData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderAircraftOwnershipData = renderAircraftOwnershipData;
